// extracted by mini-css-extract-plugin
export var compactFilters = "_f9-4";
export var detailImage = "_f9-1";
export var dropdownContainer = "_f9-2";
export var imageContainer = "_f9-0";
export var selectedCard = "_f9-3";